import { DefaultLinkModel } from "@projectstorm/react-diagrams";

export class CanvasInitModel extends DefaultLinkModel {
	constructor () {
		super({
			type: "canvas-init"
		});
	}
}
